<template>
  <div class="row ma-0 pa-0">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-left">
      <span class="form-title">Dados cadastrais</span>

      <div class="row">
        <ed-input-select
          class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5"
          v-model="formData.strTipoPessoa"
          name="strTipoPessoa"
          label="Pessoa"
          required
          rules="required"
          :disabled="formData.intTipoCadastroGeralId == 1339"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PJ'"
          class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7"
          v-model="formData.strCnpj"
          name="strCnpj"
          label="CNPJ"
          required
          v-mask="'99.999.999/9999-99'"
          rules="required|cnpj"
          @blur="getDadosDocumento"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PF'"
          class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7"
          v-model="formData.strCnpj"
          name="strCnpj"
          label="CPF"
          v-mask="'999.999.999-99'"
          required
          rules="required|cpf"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-12 col-lg-812 col-xl-12"
          v-model="formData.strNome"
          name="strNome"
          label="Nome"
          required
          rules="required"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PJ'"
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strInscricaoEstadual"
          name="strInscricaoEstadual"
          label="Inscrição Estadual"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PJ'"
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strInscricaoMunicipal"
          name="strInscricaoMunicipal"
          label="Inscrição Municipal"
        />

        <ed-input-select
          v-if="formData.strTipoPessoa == 'PJ'"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          v-model="formData.intCrt"
          name="intCrt"
          label="CRT"
          :items="[{intId:1,strNome:'1 - SIMPLES NACIONAL'},{intId:2,strNome:'2 - SIMPLES NACIONAL - EXCESSO DE SUBLIMITE DE RECEITA BRUTA'},{intId:3,strNome:'3 - REGIME NORMAL'}]"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PF'"
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
          v-model="formData.strRg"
          name="strRg"
          label="RG"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PF'"
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
          v-model="formData.strNit"
          name="strNit"
          label="NIT"
          rules="pis"
          v-mask="'999.99999.99-9'"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PF'"
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
          v-model="formData.strCei"
          name="strCei"
          rules="cei"
          v-mask="'99.999.99999/99'"
          label="CEI"
        />

        <ed-input-auto-complete
          v-if="formData.strTipoPessoa == 'PJ'"
          class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
          v-model="formData.strCnae"
          label="Cnae"
          name="strCnae"
          route="Common/Cnae"
          itemValue="strCodigo"
          @selected="setCnae"
        />

        <ed-input-text
          v-if="formData.strTipoPessoa == 'PJ'"
          type="number"
          class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
          v-model="formData.intGrauRisco"
          name="intGrauRisco"
          label="Grau de Risco"
        />
      </div>

      <span class="form-title">Contato do Responsável</span>

      <div class="row">
        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strNomeResponsavel"
          name="strNomeResponsavel"
          label="Nome"
          rules="required"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strDocumentoResponsavel"
          name="strDocumentoResponsavel"
          label="CPF"
          rules="required|cpf"
          v-mask="'999.999.999-99'"
        />
        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strTelefoneResponsavel"
          name="Telefone"
          label="Telefone"
          v-mask="'(99) 9999-9999'"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strCelularResponsavel"
          name="strCelularResponsavel"
          label="Celular"
          v-mask="'(99) 99999-9999'"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          v-model="formData.strEmailResponsavel"
          name="strEmailResponsavel"
          label="Email"
          rules="required|email"
        />
      </div>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-left">
      <span class="form-title">Endereço</span>
      <ed-endereco :formData="formData" />

      <span class="form-title">Outras Informações</span>

      <div class="row">
        <ed-input-file
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          v-model="formData.arquivo_logo"
          name="strUrlLogo"
          label="Alterar Logo do Sistema"
          :hint="formData.strUrlLogo ? formData.strUrlLogo : ''"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strUrlFacebook"
          name="strUrlFacebook"
          label="Facebook"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strUrlInstagram"
          name="strUrlInstagram"
          label="Instagram"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strUrlTwitter"
          name="strUrlTwitter"
          label="Twitter"
        />

        <ed-input-text
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
          v-model="formData.strUrlYoutube"
          name="strUrlYoutube"
          label="Youtube"
        />
      </div>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left"
      v-if="objDadosDocumento"
    >
      <ed-alert type="warning">
        <p><b>Informações da Empresa na Receita Federal</b></p>
        <span class="ed-full-width">
          Data de Abertura: {{ objDadosDocumento.strDataAbertura }}
        </span>

        <span class="ed-full-width">
          Data Última Atualização:
          {{ objDadosDocumento.strDataUltimaAtualizacao }}
        </span>

        <span class="ed-full-width">
          Situação: {{ objDadosDocumento.boolStatus ? "Ativo" : "Inativo" }}
        </span>
      </ed-alert>
    </div>
  </div>
</template>

<script>
import EdEndereco from "@/components/cadastro/geral/partials/endereco";
import {
  EdAlert,
  EdInputText,
  EdInputAutoComplete,
  EdInputTextArea,
  EdInputSelect,
  EdInputFile,
} from "@/components/common/form";

export default {
  name: "pageCadastroFuncao",
  props: {
    formData: {
      type: [Object],
      required: true,
      default: function () {
        return {};
      },
    },
  },
  components: {
    EdAlert,
    EdInputText,
    EdInputAutoComplete,
    EdInputTextArea,
    EdInputSelect,
    EdInputFile,
    EdEndereco,
  },
  inject: ["bind"],
  provide() {
    return {};
  },
  mounted() {},
  created() {},
  data() {
    return {
      arrayCnpjConsultado: [],
      objDadosDocumento: null,
    };
  },
  watch: {},
  methods: {
    setCnae(item) {
      if (item?.strCodigo) {
        this.formData.intGrauRisco = item.intGrauRisco;
      }
    },

    getDadosDocumento() {
      if (
        !this.formData.intId &&
        this.formData.strCnpj &&
        this.$utilidade.isCnpj(this.formData.strCnpj) &&
        this.arrayCnpjConsultado.indexOf(this.formData.strCnpj) == -1
      ) {
        this.$root.$dialog.loading(true);

        this.$root.$request
          .get("Cadastro/CadastroGeral", {
            boolConsultarDocumento: true,
            strCnpj: this.formData.strCnpj,
          })
          .then((objResponse) => {
            this.$root.$dialog.loading(false);

            if (objResponse.status == 200 && objResponse.result) {
              this.objDadosDocumento = objResponse.result;

              this.arrayCnpjConsultado.push(this.formData.strCnpj);

              this.formData.strNome = objResponse.result.strNome;
              this.formData.strCnae = objResponse.result.strCnae;
              this.formData.intGrauRisco = objResponse.result.intGrauRisco;
              this.formData.strTelefone = objResponse.result.strTelefone;
              this.formData.endereco = Object.assign(
                objResponse.result.endereco,
                {}
              );

              if (!this.formData.setores || !this.formData.setores.length) {
                this.formData.setores = Object.assign(
                  [
                    {
                      intId: 0,
                      intGhe: 1,
                      strNome: "ADMINISTRATIVO",
                      boolAtivo: true,
                    },
                  ],
                  {}
                );
              }

              if (!!this.formData.unidades || this.formData.unidades.length) {
                this.formData.unidades = Object.assign(
                  [
                    {
                      intId: 0,
                      intUnidade: 1,
                      strNome: "MATRIZ",
                      strCnpj: this.$utilidade.onlyNumber(
                        this.formData.strCnpj
                      ),
                      intTipoDocumentoId: 1,
                      intTipoEstabelecimentoId: 1,
                      boolAtivo: true,
                    },
                  ],
                  {}
                );
              }

              if (objResponse.result.emails.length) {
                if (!this.formData.emails || !this.formData.emails.length) {
                  this.formData.emails = Object.assign(
                    objResponse.result.emails,
                    {}
                  );
                }
              }

              this.$forceUpdate();
            }
          });
      }
    },
  },
};
</script>
